var N = /* @__PURE__ */ ((E) => (E[E.CREATED = 201] = "CREATED", E[E.NO_CONTENT = 204] = "NO_CONTENT", E[E.BAD_REQUEST = 400] = "BAD_REQUEST", E[E.UNAUTHORIZED = 401] = "UNAUTHORIZED", E[E.FORBIDDEN = 403] = "FORBIDDEN", E[E.NOT_FOUND = 404] = "NOT_FOUND", E[E.CONFLICT = 409] = "CONFLICT", E[E.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", E[E.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", E))(N || {});
export {
  N as HttpStatus
};
//# sourceMappingURL=http-status.js.map
